"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sxPopper = void 0;
exports.sxPopper = {
    ".MuiMenuItem-root": {
        fontSize: "var(--font-size-medium)",
        fontFamily: "var(--font-family)",
        "&.Mui-selected, &:hover, &.Mui-selected:hover": {
            backgroundColor: "var(--select-option-selected-background-color)",
            color: "var(--select-option-selected-color)",
        },
    },
    ".MuiPickersLayout-actionBar": {
        padding: "var(--padding-small)",
        display: "flex",
        justifyContent: "flex-end",
    },
};
//# sourceMappingURL=styles.js.map